import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

type Props = ButtonProps & {
  children: React.ReactNode;
  isLoading?: boolean;
};

export const MainButton: React.FC<Props> = ({
  children,
  isLoading = false,
  ...props
}) => {
  let disableStyle = {};

  switch (props.variant) {
    case 'text':
      disableStyle = {
        ':disabled': {
          color: '#A3A8AD',
        },
      };
      break;
    case 'contained':
      disableStyle = {
        ':disabled': {
          backgroundColor: '#E4E7EB',
          color: '#A3A8AD',
        },
      };
  }

  return (
    <Button
      {...props}
      sx={{
        paddingY: 1.75,
        borderRadius: 50,
        ...disableStyle,
        ...props.sx,
      }}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};
